import React, { Component } from 'react';
import axios from 'axios';
import RadioCard from '../komponenten/fragentyp/Radiocard';
import Slidercard from '../komponenten/fragentyp/Slidercard';
import Optionscard from '../komponenten/fragentyp/Optionscard';
import Spinner from 'react-bootstrap/Spinner';
import Mapscard from '../komponenten/fragentyp/Mapscard';
import Footer from '../komponenten/footer/Footer';
import Phonecard from '../komponenten/fragentyp/Phonecard';
import Emailcard from '../komponenten/fragentyp/Emailcard';
import ArtderBeratung from '../komponenten/fragentyp/ArtderBeratung';
import Namecard from '../komponenten/fragentyp/Namecard';
import NamecardValidation from '../komponenten/fragentyp/NamecardValidation';
import EmailcardValidation from '../komponenten/fragentyp/EmailcardValidation';
import RadioCardOther from '../komponenten/fragentyp/RadiocardOther';
import UpperLowerCard from '../komponenten/fragentyp/UpperLowerCard';
import { useHistory } from 'react-router-dom';
import { CardContent } from '@material-ui/core';

import checkgreen from '../media/checkgreen.png';

export default class Main extends Component {
  constructor(props) {
    super(props);
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.handleTime = this.handleTime.bind(this);

    this.handleMessage = this.handleMessage.bind(this);

    this.handleFinished = this.handleFinished.bind(this);
    this.deleteStorage = this.deleteStorage.bind(this);

    this.handleUpdate = this.handleUpdate.bind(this);
    this.loadcards = this.loadcards.bind(this);

    this.sendResolutionAndUrl = this.sendResolutionAndUrl.bind(this);

    this.getNextCard = this.getNextCard.bind(this);
    this.state = {
      cardsloaded: false,
      paramstr: '',
    };
    this.sendResolutionAndUrl(350);
  }
  updateDimensions = () => {
    this.sendResolutionAndUrl();
  };

  handleTime = () => {
    if (this.state.daten != undefined) {
      this.timerCounter = 0;
      let cardID =
        this.state.daten['chain'].length > 0
          ? this.state.daten['chain'][
              this.state.daten['chain'].length - 1
            ].toString()
          : this.state.daten['chain'][0].toString();
      axios
        .post('https://iw.server-novis.com/vupdate', {
          gettime: { timevar: cardID, timex: this.state.daten['timex'] },
        })
        .catch(function (error) {
          //ausgabe
        });
      clearTimeout(this.time);
      this.time = window.setInterval(() => {
        if (this.timerCounter < 5) {
          cardID =
            this.state.daten['chain'].length > 0
              ? this.state.daten['chain'][
                  this.state.daten['chain'].length - 1
                ].toString()
              : this.state.daten['chain'][0].toString();

          axios
            .post('https://iw.server-novis.com/vupdate', {
              gettime: {
                timevar: cardID,
                timex: this.state.daten['timex'],
              },
            })
            .catch(function (error) {
              //ausgabe
            });
        }
        this.timerCounter += 1;
      }, 10000);
    }
  };
  handleMessage = e => {
    const params = {};

    if (e.data != undefined) {
      e.data
        .substr(1)
        .split('&')
        .forEach(pair => {
          let [key, value] = pair.split('=');
          params[key] = value;
        });
    }
    let x = JSON.stringify(params);
    if (this.state.paramstr != x) {
      this.setState({ paramstr: JSON.stringify(params) });
    }
  };
  sendResolutionAndUrl = x => {
    if (x == undefined) {
      x = document.getElementById('root').offsetHeight;
    }
    let d = {};
    d['redirect'] = x == -1 ? 1 : 0;
    d['hoehe'] = x == -1 ? document.getElementById('root').offsetHeight : x;
    d['wurl'] = this.state.wurl != undefined ? this.state.wurl : '';

    let grund = '';

    if (this.state.daten?.info['8']?.selection == '0') {
      grund = 'Verkauf';
    } else if (this.state.daten?.info['8']?.selection == '1') {
      grund = 'Kauf';
    } else if (this.state.daten?.info['8']?.selection == '2') {
      grund = 'Sonstiges';
    }

    let parameter =
      '?strasse=' +
      this.state.daten?.info['14']?.adresse?.strasse +
      ' ' +
      this.state.daten?.info['14']?.adresse?.hausnummer +
      '&plz=' +
      this.state.daten?.info['14']?.adresse?.plz +
      '&ort=' +
      this.state.daten?.info['14']?.adresse?.stadt +
      '&anrede=' +
      this.state.daten?.info['15']?.anrede +
      '&nachname=' +
      this.state.daten?.info['15']?.nachname +
      '&grund=' +
      grund +
      '&phupper=' +
      this.state.daten?.info['-1']?.phupper +
      '&pmiddle=' +
      this.state.daten?.info['-1']?.phmiddle +
      '&phlower=' +
      this.state.daten?.info['-1']?.phlower;

    parameter = parameter
      .replace('&phupper=undefined', '')
      .replace('&pmiddle=undefined', '')
      .replace('&phlower=undefined', '')
      .replace('&phupper=&pmiddle=&phlower=', '');

    if (d['wurl'] != undefined) {
      if (d['wurl'].length > 6) {
        d['wurl'] = encodeURI(d['wurl'] + parameter);
      }
    }

    if (d['redirect'] == 1) {
      let cardID =
        this.state.daten['chain'].length > 0
          ? this.state.daten['chain'][
              this.state.daten['chain'].length - 1
            ].toString()
          : this.state.daten['chain'][0].toString();
      if (this.state.cardcontent[cardID]['typ'] != 'fertig') {
        d['redirect'] = 0;
      }
    }

    if (window && window.parent) {
      window.parent.postMessage(JSON.stringify(d), '*');
    }
  };

  timeKarteGestartet = 0;

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  loadcards = timex => {
    let queryParams = new URLSearchParams(window.location.search);
    let userid = queryParams.get('userid');
    var config = {
      method: 'get',
      url: 'https://iw.server-novis.com/v3.json',
      headers: {},
    };

    config.url =
      timex == undefined
        ? config.url + '?gettimex=1'
        : config.url + '?timex=' + timex;
    config.url =
      userid == undefined ? config.url : config.url + '&userid=' + userid;
    axios(config)
      .then(response => {
        let x = response.data;

        if ('error' in x) {
          this.setState({
            error: x['error'],
          });
        } else {
          if (timex == undefined) {
            if (x.info != undefined) {
              x['info'].userid = userid;
            }

            this.setState(
              {
                cardcontent: x['cardcontent'],
                daten: x['info'],
                wurl: x['info']['wurl'],
                cardsloaded: true,
              },
              () => {
                let datencopy = JSON.parse(JSON.stringify(this.state.daten));

                try {
                  localStorage.setItem('daten', JSON.stringify(datencopy));
                } catch (e) {
                  console.log(e);
                }
              }
            );
          } else {
            this.setState({
              cardcontent: x['cardcontent'],
              wurl: x['info']['wurl'],
              cardsloaded: true,
            });
          }
        }
        this.sendResolutionAndUrl();
      })
      .catch(function (error) {
        //ausgabe
      });
  };

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    window.addEventListener('message', this.handleMessage);
    let lStorageData = undefined;

    try {
      lStorageData = localStorage.getItem('daten');
    } catch (e) {
      console.log(e);
    }

    if (lStorageData != undefined) {
      let queryParams = new URLSearchParams(window.location.search);
      let userid = queryParams.get('userid');
      let datenx = JSON.parse(localStorage.getItem('daten'));

      if (datenx.userid == undefined || datenx.userid != userid) {
        this.loadcards();
      } else {
        this.setState(
          {
            daten: datenx,
          },
          () => {
            this.loadcards(this.state.daten['timex']);
          }
        );
      }
    } else {
      this.loadcards();
    }
  }
  componentDidUpdate() {
    this.sendResolutionAndUrl();
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
    clearTimeout(this.time);
  }
  handleNext = daten => {
    let cardID =
      daten['chain'].length > 0
        ? daten['chain'][daten['chain'].length - 1].toString()
        : daten['chain'][0].toString();

    if (this.state.cardcontent[cardID]['nachfolger'].length == 1) {
      daten['chain'].push(this.state.cardcontent[cardID]['nachfolger'][0]);
    }
    let api = 'vupdate';

    if (this.state.cardcontent[cardID]['nachfolger'].length > 1) {
      if (this.state.cardcontent[cardID]['nachfolgvar'] == 1) {
        let index = daten['info'][cardID]['selection'];
        daten['chain'].push(
          this.state.cardcontent[cardID]['nachfolger'][index]
        );
      } else {
        let path = -1;
        for (let key in this.state.cardcontent['paths']) {
          let bSame = 1;
          for (
            let i = 0;
            i < daten['chain'].length &&
            i < this.state.cardcontent['paths'][key].length;
            i++
          ) {
            if (this.state.cardcontent['paths'][key][i] != daten['chain'][i]) {
              bSame = 0;
            }
          }
          if (bSame == 1) {
            path = key;
          }
        }
        if (path != -1) {
          daten['chain'].push(
            this.state.cardcontent['paths'][path][daten['chain'].length]
          );
        }
      }
    }
    if (daten['chain'][daten['chain'].length - 1] == -1) {
      api = 'submitresults';
    }

    let datencopy = JSON.parse(JSON.stringify(daten));
    datencopy['paramstr'] = this.state.paramstr;

    this.setState({ daten: datencopy }, () => {
      this.handleTime();
    });

    try {
      localStorage.setItem('daten', JSON.stringify(datencopy));
    } catch (e) {
      console.log(e);
    }

    axios
      .post('https://iw.server-novis.com/' + api, {
        daten: JSON.stringify(datencopy),
      })
      .catch(function (error) {
        //ausgabe
      });

    this.sendResolutionAndUrl();
  };

  handleUpdate = daten => {
    let datencopy = JSON.parse(JSON.stringify(daten));
    this.setState({ daten: datencopy });
    try {
      localStorage.setItem('daten', JSON.stringify(datencopy));
    } catch (e) {
      console.log('Could not write Local Storage');
    }
  };

  handleBack = () => {
    let queryParams = new URLSearchParams(window.location.search);

    let datencopy = JSON.parse(JSON.stringify(this.state.daten));
    datencopy['chain'].length > 1 ? datencopy['chain'].pop() : 0;
    this.setState({ daten: datencopy }, () => {
      this.handleTime();
    });

    try {
      localStorage.setItem('daten', JSON.stringify(datencopy));
    } catch (e) {
      console.log('Could not write Local Storage');
    }
  };

  deleteStorage = () => {
    try {
      localStorage.clear();
    } catch (e) {
      console.log('Could not clear Local Storage');
    }
  };

  handleCheck = () => {
    let datencopy = JSON.parse(JSON.stringify(this.state.daten));

    let cardID = datencopy['chain'][datencopy['chain'].length - 1];
    if (cardID in datencopy['info'] === true) {
      datencopy['info'][cardID]['showerrors'] = 1;
    }

    if (this.state.cardcontent[cardID]?.typ === 'nameverify') {
      if (datencopy['info'][cardID]['weiterButtonAllow'] == 1) {
        let telefonInfos = {
          countryCode: datencopy.info[cardID]?.countrycode,
          telefon: datencopy.info[cardID]?.telefon,
        };

        axios
          .post('https://iw.server-novis.com/' + 'validatephone', {
            daten: JSON.stringify(telefonInfos),
          })
          .catch(function (error) {
            //ausgabe
          })
          .then(response => {
            if (response?.data == 'Valid') {
              let datencopy = JSON.parse(JSON.stringify(this.state.daten));
              datencopy['info'][cardID]['phoneval'] = 1;
              this.setState({ daten: datencopy });
              this.handleNext(this.state.daten);
            } else {
              let datencopy = JSON.parse(JSON.stringify(this.state.daten));
              datencopy['info'][cardID]['validiert'] = 0;
              this.setState({ daten: datencopy });
            }
          });
      }
    }

    if (this.state.cardcontent[cardID]?.typ === 'emailverify') {
      if (datencopy['info'][cardID]['weiterButtonAllow'] == 1) {
        axios
          .post('https://iw.server-novis.com/' + 'validateemail', {
            daten: JSON.stringify({
              email: datencopy.info[cardID]?.mailadress,
            }),
          })
          .catch(function (error) {
            //ausgabe
          })
          .then(response => {
            if (response?.data == 'Valid') {
              let datencopy = JSON.parse(JSON.stringify(this.state.daten));
              datencopy['info'][cardID]['emailval'] = 1;
              this.setState({ daten: datencopy });
              this.handleNext(this.state.daten);
            } else {
              let datencopy = JSON.parse(JSON.stringify(this.state.daten));
              datencopy['info'][cardID]['validiert'] = 0;
              this.setState({ daten: datencopy });
            }
          });
      } else {
        datencopy['info'][cardID]['validiert'] = 0;
      }
    }

    this.setState({ daten: datencopy });

    try {
      localStorage.setItem('daten', JSON.stringify(datencopy));
    } catch (e) {
      console.log('Could not write Local Storage');
    }
  };

  handleFinished = () => {
    try {
      localStorage.removeItem('daten');
    } catch (e) {
      console.log('Could not clear Local Storage');
    }
    this.loadcards();
  };

  timer = '';

  getNextCard(daten, cardcontent, handleNext, handleUpdate) {
    let cardID = daten['chain'][daten['chain'].length - 1];
    if (cardID in daten['info'] === false) {
      daten['info'][cardID] = {};
    }

    let x = 0;

    if (x) {
      return (
        <Mapscard
          daten={daten}
          handleNext={handleNext}
          handleUpdate={handleUpdate}
          cardID={cardID}
          cardcontent={cardcontent[14]}
          url={cardcontent['url']}
          hovercolor={this.state.daten.hovercolor}
        />
      );
    }

    if (cardcontent[cardID]['typ'] == 'radio') {
      return (
        <RadioCard
          daten={daten}
          handleNext={handleNext}
          handleUpdate={handleUpdate}
          cardID={cardID}
          cardcontent={cardcontent[cardID]}
          url={cardcontent['url']}
          hovercolor={this.state.daten.hovercolor}
        />
      );
    } else if (cardcontent[cardID]['typ'] == 'radioother') {
      return (
        <RadioCardOther
          daten={daten}
          handleNext={handleNext}
          handleUpdate={handleUpdate}
          cardID={cardID}
          cardcontent={cardcontent[cardID]}
          url={cardcontent['url']}
          hovercolor={this.state.daten.hovercolor}
        />
      );
    } else if (cardcontent[cardID]['typ'] == 'slider') {
      return (
        <Slidercard
          daten={daten}
          handleNext={handleNext}
          handleUpdate={handleUpdate}
          cardID={cardID}
          cardcontent={cardcontent[cardID]}
          url={cardcontent['url']}
          hovercolor={this.state.daten.hovercolor}
        />
      );
    } else if (cardcontent[cardID]['typ'] == 'options') {
      return (
        <Optionscard
          daten={daten}
          handleNext={handleNext}
          handleUpdate={handleUpdate}
          cardID={cardID}
          cardcontent={cardcontent[cardID]}
          url={cardcontent['url']}
          hovercolor={this.state.daten.hovercolor}
        />
      );
    } else if (cardcontent[cardID]['typ'] == 'date') {
      return (
        <Slidercard
          daten={daten}
          handleNext={handleNext}
          handleUpdate={handleUpdate}
          cardID={cardID}
          cardcontent={cardcontent[cardID]}
          url={cardcontent['url']}
          hovercolor={this.state.daten.hovercolor}
        />
      );
    } else if (cardcontent[cardID]['typ'] == 'maps') {
      return (
        <Mapscard
          daten={daten}
          handleNext={handleNext}
          handleUpdate={handleUpdate}
          cardID={cardID}
          cardcontent={cardcontent[cardID]}
          url={cardcontent['url']}
          hovercolor={this.state.daten.hovercolor}
        ></Mapscard>
      );
    } else if (cardcontent[cardID]['typ'] == 'name') {
      return (
        <Namecard
          daten={daten}
          handleNext={handleNext}
          handleUpdate={handleUpdate}
          cardID={cardID}
          cardcontent={cardcontent[cardID]}
          hovercolor={this.state.daten.hovercolor}
        ></Namecard>
      );
    } else if (cardcontent[cardID]['typ'] == 'emailverify') {
      return (
        <EmailcardValidation
          daten={daten}
          handleNext={handleNext}
          handleUpdate={handleUpdate}
          cardID={cardID}
          cardcontent={cardcontent[cardID]}
          hovercolor={this.state.daten.hovercolor}
        ></EmailcardValidation>
      );
    } else if (cardcontent[cardID]['typ'] == 'nameverify') {
      let country = 'de';
      for (let key in cardcontent) {
        if (cardcontent[key]?.typ == 'maps') {
          if (this.state.daten.info[key].adresse.land == 'Österreich') {
            country = 'at';
          }
          if (this.state.daten.info[key].adresse.land == 'Schweiz') {
            country = 'ch';
          }
        }
      }

      return (
        <NamecardValidation
          daten={daten}
          handleNext={handleNext}
          handleUpdate={handleUpdate}
          cardID={cardID}
          cardcontent={cardcontent[cardID]}
          country={country}
          hovercolor={this.state.daten.hovercolor}
        ></NamecardValidation>
      );
    } else if (cardcontent[cardID]['typ'] == 'phone') {
      return (
        <Phonecard
          daten={daten}
          handleNext={handleNext}
          handleUpdate={handleUpdate}
          cardID={cardID}
          cardcontent={cardcontent[cardID]}
          hovercolor={this.state.daten.hovercolor}
        ></Phonecard>
      );
    } else if (cardcontent[cardID]['typ'] == 'email') {
      return (
        <Emailcard
          daten={daten}
          handleNext={handleNext}
          handleUpdate={handleUpdate}
          cardID={cardID}
          cardcontent={cardcontent[cardID]}
          hovercolor={this.state.daten.hovercolor}
        ></Emailcard>
      );
    } else if (cardcontent[cardID]['typ'] == 'artderberatung') {
      return (
        <ArtderBeratung
          daten={daten}
          handleNext={handleNext}
          handleUpdate={handleUpdate}
          cardID={cardID}
          cardcontent={cardcontent[cardID]}
          url={cardcontent['url']}
          hovercolor={this.state.daten.hovercolor}
        ></ArtderBeratung>
      );
    } else if (cardcontent[cardID]['typ'] == 'fertig') {
      if (
        cardcontent[cardID]['upperlower'] === '1' &&
        this.state.daten.info[cardID]?.phupper === undefined
      ) {
        return (
          <UpperLowerCard
            daten={daten}
            handleNext={handleNext}
            handleUpdate={handleUpdate}
            cardID={cardID}
            cardcontent={cardcontent[cardID]}
            timex={this.state.daten['timex']}
            hovercolor={this.state.daten.hovercolor}
          ></UpperLowerCard>
        );
      }

      this.deleteStorage();

      if (
        this.state.wurl != undefined &&
        this.state.redirect != 1 &&
        this.state.wurl != ''
      ) {
        if (this.state.daten.info[cardID]?.phupper === undefined) {
          setTimeout(() => {
            this.sendResolutionAndUrl(-1);
          }, 3000);
        } else {
          this.sendResolutionAndUrl(-1);
        }
      }

      return (
        <div
          className="h-full flex flex-col justify-center  text-center mt-20px mb-20px"
          id="endcard"
        >
          <div className="flex gap-10px justify-center place-items-center">
            <img
              style={{ height: '120px', minHeight: '120px' }}
              src={checkgreen}
            />
          </div>
          <div>
            <br />
            Das hat geklappt.
            <br /> Vielen Dank für Ihre Anfrage. <br />
            Wir werden uns bei Ihnen melden.
          </div>
        </div>
      );
    } else {
      return <div>Eingabefehler bitte Laden Sie die Seite neu</div>;
    }
  }

  render() {
    let renderObjekt;
    if (this.state.cardsloaded === false) {
      if (this.state.error == undefined) {
        renderObjekt = (
          <div className="bg-gray-800 h-screen flex justify-center items-center">
            <div className="h-500px w-800px bg-white-1 overflow-hidden flex flex-col justify-center items-center">
              <Spinner
                animation="border"
                role="status"
                style={{ width: '10rem', height: '10rem' }}
              >
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          </div>
        );
      } else {
        renderObjekt = (
          <div className="bg-gray-800 h-screen flex justify-center items-center">
            <div className="h-500px w-800px bg-white-1 overflow-hidden flex flex-col justify-center items-center">
              {this.state.error}
            </div>
          </div>
        );
      }
    } else {
      let cardID =
        this.state.daten['chain'].length > 0
          ? this.state.daten['chain'][
              this.state.daten['chain'].length - 1
            ].toString()
          : this.state.daten['chain'][0].toString();

      let weiterbutton = false;
      let showerror = undefined;
      let finished = false;
      if (
        this.state.cardcontent[cardID]['typ'] == 'slider' ||
        this.state.cardcontent[cardID]['typ'] == 'options' ||
        this.state.cardcontent[cardID]['typ'] == 'phone' ||
        this.state.cardcontent[cardID]['typ'] == 'date'
      ) {
        weiterbutton = 1;
      }

      if (this.state.daten['info'][cardID]) {
        if ('weiterButtonAllow' in this.state.daten['info'][cardID])
          if (this.state.daten['info'][cardID]['weiterButtonAllow'] == 1) {
            weiterbutton = 1;
          } else {
            showerror = 1;
          }
      }

      if (this.state.cardcontent[cardID]?.typ === 'nameverify') {
        if (this.state.daten['info'][cardID]?.phoneval != 1) {
          showerror = 1;
        }
      }
      if (this.state.cardcontent[cardID]?.typ === 'emailverify') {
        if (this.state.daten['info'][cardID]?.emailval != 1) {
          showerror = 1;
        }
      }

      if (this.state.cardcontent[cardID]['typ'] == 'fertig') {
        finished = true;
      }

      renderObjekt = (
        <div className="h-full w-full md:w-800px  bg-white-1 overflow-hidden flex flex-col justify-between md:h-500px ">
          <div className="animate__animated animate__slideInLeft h-full">
            {this.getNextCard(
              this.state.daten,
              this.state.cardcontent,
              this.handleNext,
              this.handleUpdate
            )}
          </div>

          <Footer
            finished={finished}
            shownext={weiterbutton}
            showerror={showerror}
            handleBack={this.handleBack}
            handleNext={this.handleNext}
            handleCheck={this.handleCheck}
            handleFinished={this.handleFinished}
            daten={this.state.daten}
            step={this.state.daten['chain'].length}
          />
        </div>
      );
    }
    return (
      <div
        className="flex justify-center items-center "
        style={{ height: '100%' }}
      >
        {renderObjekt}
      </div>
    );
  }
}
